module.exports = __webpack_public_path__ + "static/media/Jeong Sohn.4491223b.png";